import { render, staticRenderFns } from "./rules.vue?vue&type=template&id=a2eb1542&scoped=true"
import script from "./rules.vue?vue&type=script&lang=js"
export * from "./rules.vue?vue&type=script&lang=js"
import style0 from "./rules.vue?vue&type=style&index=0&id=a2eb1542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2eb1542",
  null
  
)

export default component.exports